export default __webpack_public_path__ + "static/04-2f8377e5d6a1cbd80ad32726684c0503.png";